(function () {
  'use strict';

  var root = document.querySelector('[data-homepage-chopstick-hero]');
  if (!root) return;

  var host = root.querySelector('[data-homepage-chopstick-viewer]');
  if (!host || root.getAttribute('data-viewer-initialized') === 'true') return;
  root.setAttribute('data-viewer-initialized', 'true');
  host.setAttribute('aria-busy', 'true');

  var slide = root.closest('[data-homepage-chopstick-slide]');
  var slider = root.closest('.homepage-slideshow');
  var reducedMotionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var reducedMotion = !!(reducedMotionQuery && reducedMotionQuery.matches);
  var narrowScreen = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  var homepageSleeveScale = narrowScreen ? 1.12 : 1.04;
  var homepagePreviewVerticalOffset = .025;
  var sleeveHalfWidth = 3.8 * homepageSleeveScale;
  var sleeveHalfHeight = .36 * homepageSleeveScale;
  var sleeveHalfDepth = .0875 * homepageSleeveScale;
  var textureWidth = 1680;
  var textureHeight = 160;
  var frontCanvas = createCanvas();
  var backCanvas = createCanvas();
  var transitionFront = createCanvas();
  var transitionBack = createCanvas();
  var targetFront = createCanvas();
  var targetBack = createCanvas();
  var previewSequence = [0, 1, 5, 6, 4, 3, 2, 7];
  var startOnFrontSamples = { 2: true, 5: true, 6: true, 7: true };
  var startOnBackSamples = { 3: true };
  var sequenceIndex = 0;
  var currentSample = previewSequence[sequenceIndex];
  var currentSampleReversed = false;
  var rotationDuration = 12000;
  var sampleChangesPerRotation = 4;
  var sleeveYawOffset = .42;
  var broadFaceVisibility = .82;
  var alternatingChangeAdvance = 240;
  var earlyChangeAt = (
    (sleeveYawOffset + Math.acos(broadFaceVisibility)) /
    (Math.PI * 2)
  ) * rotationDuration - alternatingChangeAdvance;
  var changePoints = [
    earlyChangeAt,
    rotationDuration / 2,
    earlyChangeAt + rotationDuration / 2,
    rotationDuration
  ];
  var changeIndex = 0;
  var nextSampleAt = changePoints[changeIndex];
  var transitionStartedAt = -1;
  var transitionDuration = 750;
  var elapsed = 0;
  var lastFrameTime = 0;
  var frameRequest = null;
  var inViewport = true;
  var destroyed = false;
  var renderer;
  var scene;
  var camera;
  var previewGroup;
  var sleeve;
  var frontTexture;
  var backTexture;
  var framedWidth = 0;
  var framedHeight = 0;
  var renderedWidth = 0;
  var renderedHeight = 0;
  var imageCache = {};
  var sizeObserver = null;
  var layoutObserver = null;
  var lifecycleBound = false;
  var revealScheduled = false;
  var artworkUrls = {
    'luxury-sushi': root.getAttribute('data-sample-luxury-sushi'),
    'modern-ramen': root.getAttribute('data-sample-modern-ramen'),
    'cafe': root.getAttribute('data-sample-cafe'),
    'korean-bbq': root.getAttribute('data-sample-korean-bbq'),
    'traditional-izakaya': root.getAttribute('data-sample-traditional-izakaya'),
    'text-only': root.getAttribute('data-sample-text-only'),
    'instructional': root.getAttribute('data-sample-instructional'),
    'locational': root.getAttribute('data-sample-locational')
  };

  function createCanvas() {
    var canvas = document.createElement('canvas');
    canvas.width = textureWidth;
    canvas.height = textureHeight;
    return canvas;
  }

  function textObject(text, x, y, width, size, font, color, options) {
    options = options || {};
    return {
      type: 'text',
      text: text,
      x: x,
      y: y,
      width: width,
      fontSize: size,
      fontFamily: font,
      fontStyle: options.fontStyle || 'normal',
      letterSpacing: options.letterSpacing || 0,
      fill: color,
      align: options.align || 'center',
      rotation: options.rotation || 0
    };
  }

  function vectorObject(sampleKey, crop, x, y, width, height) {
    return {
      type: 'image',
      sampleKey: sampleKey,
      crop: crop,
      x: x,
      y: y,
      width: width,
      height: height
    };
  }

  var samples = [
    {
      key: 'luxury-sushi',
      name: 'Classic',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('luxury-sushi', [102, 247, 128, 54], .16, .47, .17, .5),
          textObject('(805) 523-2954', .52, .48, .28, .16, 'Courier New', '#202020', { letterSpacing: .018 }),
          vectorObject('luxury-sushi', [636, 250, 119, 47], .84, .47, .15, .48)
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('www.sushiplanetmoorpark.com', .17, .22, .27, .09, 'Arial', '#202020', { rotation: 180 }),
          textObject('(805) 523-2954', .17, .41, .19, .09, 'Georgia', '#202020', { rotation: 180 }),
          textObject('Suite # A', .17, .57, .13, .085, 'Georgia', '#202020', { rotation: 180 }),
          textObject('537 New Los Angeles Ave.,', .17, .74, .25, .09, 'Georgia', '#202020', { rotation: 180 }),
          vectorObject('luxury-sushi', [289, 328, 263, 2], .52, .22, .35, .02),
          textObject('ORDER ONLINE', .52, .38, .3, .1, 'Arial', '#202020'),
          textObject('http://www.sushiplanetmoorpark.com', .52, .61, .38, .1, 'Arial', '#202020', { fontStyle: 'bold' }),
          vectorObject('luxury-sushi', [289, 367, 263, 2], .52, .76, .35, .02),
          vectorObject('luxury-sushi', [622, 329, 126, 51], .87, .5, .125, .5)
        ]
      }
    },
    {
      key: 'modern-ramen',
      name: 'Modern',
      front: {
        background: '#ffffff',
        objects: [
          textObject('MOKU', .5, .40, .28, .36, 'Times New Roman', '#202020'),
          textObject('PACIFIC PALISADES', .5, .69, .28, .11, 'Arial', '#202020', { fontStyle: 'bold', letterSpacing: .008 })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('TAKEOUTS • RESERVATIONS • PARTY PLATTER', .27, .36, .44, .12, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('(424) 272 9339 | (424) 272 9329', .23, .66, .36, .12, 'Arial', '#202020'),
          textObject('DELIVERIES\nMENU', .77, .5, .15, .12, 'Arial', '#202020', { fontStyle: 'bold' }),
          vectorObject('modern-ramen', [674, 323, 70, 52], .88, .5, .07, .5)
        ]
      }
    },
    {
      key: 'cafe',
      name: 'Simple',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('cafe', [280, 258, 283, 31], .5, .5, .36, .32)
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('@masasushila', .5, .5, .36, .24, 'Arial', '#202020', { fontStyle: 'bold' })
        ]
      }
    },
    {
      key: 'korean-bbq',
      name: 'Bold',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('korean-bbq', [90, 255, 8, 30], .5, .5, .9, .58),
          textObject('ANOMALIA', .23, .5, .36, .4, 'Georgia', '#e7e9a8'),
          textObject('EATANOMALIA.COM', .83, .5, .2, .1, 'Arial', '#e7e9a8', { letterSpacing: .008 })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vectorObject('korean-bbq', [83, 321, 675, 54], .5, .5, .84, .54)
        ]
      }
    },
    {
      key: 'traditional-izakaya',
      name: 'Traditional',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('traditional-izakaya', [86, 248, 157, 57], .17, .5, .2, .56),
          textObject('972.807.2829', .82, .27, .18, .12, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('2160 N Coit Rd #130, Richardson, TX 75080', .8, .53, .31, .085, 'Arial', '#202020'),
          textObject('UnbelievaBowlAsianGrill.com', .8, .72, .27, .08, 'Arial', '#202020'),
          vectorObject('traditional-izakaya', [638, 287, 111, 15], .82, .83, .14, .15)
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('UnbelievaBowlAsianGrill.com', .18, .2, .28, .08, 'Arial', '#202020', { rotation: 180 }),
          textObject('2160 N Coit Rd #130, Richardson, TX 75080', .18, .42, .31, .085, 'Arial', '#202020', { rotation: 180 }),
          textObject('972.807.2829', .18, .72, .18, .12, 'Arial', '#202020', { fontStyle: 'bold', rotation: 180 }),
          vectorObject('traditional-izakaya', [83, 322, 115, 15], .18, .14, .14, .15),
          vectorObject('traditional-izakaya', [600, 326, 160, 54], .82, .5, .2, .53)
        ]
      }
    },
    {
      key: 'text-only',
      name: 'Text',
      front: {
        background: '#ffffff',
        objects: [
          textObject('BAMBOO 4IRPORT', .19, .28, .22, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('2601 SPRINGER BOULEVARD\nLITTLE ROCK AR 72206', .19, .64, .25, .1, 'Arial', '#202020', { fontStyle: 'bold' }),
          vectorObject('text-only', [318, 244, 206, 62], .5, .5, .26, .6),
          textObject('BAMBOO 5HERWOOD', .81, .28, .24, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('117 COUNTRY CLUB ROAD STE A\nSHERWOOD AR 72120\n501 - 864 - 4906', .81, .65, .26, .095, 'Arial', '#202020', { fontStyle: 'bold' })
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vectorObject('text-only', [310, 318, 2, 58], .34, .5, .004, .58),
          vectorObject('text-only', [551, 318, 2, 58], .66, .5, .004, .58),
          textObject('BAMBOO 1', .18, .27, .22, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('13420 OTTER CREEK PKWY STE 2\nLITTLE ROCK AR 72211\n501 - 615 - 8500', .18, .65, .27, .095, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('BAMBOO 2', .5, .27, .2, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('4511 CAMP ROBINSON ROAD\nNORTH LITTLE ROCK AR 72218\n501 - 916 - 9034', .5, .65, .27, .095, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('BAMBOO 3', .82, .27, .2, .13, 'Arial', '#258b3a', { fontStyle: 'bold' }),
          textObject('6606 COLONEL GLENN ROAD\nLITTLE ROCK AR 72204\n501 - 406 - 7950', .82, .65, .27, .095, 'Arial', '#202020', { fontStyle: 'bold' })
        ]
      }
    },
    {
      key: 'instructional',
      name: 'Instructional',
      front: {
        background: '#5b5959',
        objects: [
          vectorObject('instructional', [68, 252, 705, 2], .5, .26, .94, .02),
          vectorObject('instructional', [68, 277, 705, 2], .5, .63, .94, .02),
          vectorObject('instructional', [230, 243, 52, 49], .26, .5, .07, .5),
          vectorObject('instructional', [283, 249, 260, 33], .52, .5, .35, .34),
          vectorObject('instructional', [565, 243, 44, 51], .72, .5, .06, .52)
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          vectorObject('instructional', [143, 319, 58, 57], .13, .53, .075, .57),
          textObject('1. Choose', .24, .28, .14, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('from our wide selection.\nTell your server your\nchoice of marinade', .24, .64, .16, .085, 'Arial', '#202020', { align: 'left' }),
          vectorObject('instructional', [294, 319, 51, 57], .35, .53, .07, .57),
          textObject('2. Grill', .45, .28, .13, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('30 to 60 sec. for sliced beef,\n3 to 4 min. for seafood in foil,\n2 to 3 min. for other items.', .45, .64, .19, .078, 'Arial', '#202020', { align: 'left' }),
          vectorObject('instructional', [458, 319, 51, 57], .57, .53, .07, .57),
          textObject('3. Dip', .66, .28, .12, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('your grilled BBQ\nitems into your\ndelicious sauce.', .66, .64, .13, .085, 'Arial', '#202020', { align: 'left' }),
          vectorObject('instructional', [588, 319, 51, 57], .75, .53, .07, .57),
          textObject('4. Love', .84, .28, .12, .12, 'Arial', '#202020', { fontStyle: 'bold', align: 'left' }),
          textObject('Yum! Enjoy freshly\ngrilled BBQ right\noff the grill.', .84, .64, .13, .085, 'Arial', '#202020', { align: 'left' })
        ]
      }
    },
    {
      key: 'locational',
      name: 'Locational',
      front: {
        background: '#ffffff',
        objects: [
          vectorObject('locational', [361, 243, 124, 63], .5, .5, .18, .61)
        ]
      },
      back: {
        background: '#ffffff',
        objects: [
          textObject('415 563 1388', .16, .28, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('1620 Post st.\nSan Francisco, CA 94115', .16, .66, .23, .105, 'Arial', '#202020'),
          textObject('408 770 3778', .39, .28, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('217 W Calaveras Blvd.\nMilpitas, CA 95035', .39, .66, .23, .105, 'Arial', '#202020'),
          textObject('650 389 6689', .62, .28, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('213 2nd Ave.\nSan Mateo, CA 94401', .62, .66, .22, .105, 'Arial', '#202020'),
          textObject('628 895 0505', .85, .24, .2, .13, 'Arial', '#202020', { fontStyle: 'bold' }),
          textObject('Inside H-Mart\n3995 Alemany Blvd\nSan Francisco, CA 94132', .85, .65, .23, .092, 'Arial', '#202020')
        ]
      }
    }
  ];

  function fontString(item, fontSize) {
    return (item.fontStyle === 'bold' ? '700 ' : item.fontStyle === 'italic' ? 'italic ' : '') +
      Math.max(1, fontSize) + 'px "' + item.fontFamily + '", sans-serif';
  }

  function measureTrackedLine(context, line, spacing) {
    var width = 0;
    for (var index = 0; index < line.length; index++) width += context.measureText(line[index]).width;
    return width + Math.max(0, line.length - 1) * spacing;
  }

  function drawTrackedLine(context, line, x, y, spacing, align) {
    var lineWidth = measureTrackedLine(context, line, spacing);
    var cursor = align === 'left' ? x : x - lineWidth / 2;
    context.textAlign = 'left';
    for (var index = 0; index < line.length; index++) {
      context.fillText(line[index], cursor, y);
      cursor += context.measureText(line[index]).width + spacing;
    }
  }

  function drawTextObject(context, item) {
    var lines = String(item.text || '').split('\n');
    var fontSize = item.fontSize * textureHeight;
    var spacing = (item.letterSpacing || 0) * textureHeight;
    var maximumWidth = item.width * textureWidth;
    var index;
    var measuredWidth = 0;

    context.font = fontString(item, fontSize);
    for (index = 0; index < lines.length; index++) {
      measuredWidth = Math.max(measuredWidth, measureTrackedLine(context, lines[index], spacing));
    }
    if (measuredWidth > maximumWidth) {
      var scale = maximumWidth / measuredWidth;
      fontSize *= scale;
      spacing *= scale;
      context.font = fontString(item, fontSize);
    }

    context.fillStyle = item.fill;
    context.textBaseline = 'middle';
    var lineHeight = fontSize * 1.08;
    var startY = -(lines.length - 1) * lineHeight / 2;
    for (index = 0; index < lines.length; index++) {
      var lineX = item.align === 'left' ? -maximumWidth / 2 : 0;
      drawTrackedLine(context, lines[index], lineX, startY + index * lineHeight, spacing, item.align);
    }
  }

  function drawImageObject(context, item) {
    var image = imageCache[item.sampleKey];
    if (!image || !image.complete || !image.naturalWidth) return;
    var crop = item.crop;
    var scaleX = image.naturalWidth / 841.89;
    var scaleY = image.naturalHeight / 595.275;
    context.drawImage(
      image,
      crop[0] * scaleX,
      crop[1] * scaleY,
      crop[2] * scaleX,
      crop[3] * scaleY,
      -item.width * textureWidth / 2,
      -item.height * textureHeight / 2,
      item.width * textureWidth,
      item.height * textureHeight
    );
  }

  function drawState(state, canvas) {
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, textureWidth, textureHeight);
    context.fillStyle = state.background;
    context.fillRect(0, 0, textureWidth, textureHeight);
    state.objects.forEach(function (item) {
      context.save();
      context.translate(item.x * textureWidth, item.y * textureHeight);
      context.rotate((item.rotation || 0) * Math.PI / 180);
      if (item.type === 'text') drawTextObject(context, item);
      else drawImageObject(context, item);
      context.restore();
    });
  }

  function drawSample(sampleIndex, front, back, reverseSides) {
    drawState(samples[sampleIndex][reverseSides ? 'back' : 'front'], front);
    drawState(samples[sampleIndex][reverseSides ? 'front' : 'back'], back);
  }

  function preloadArtwork() {
    return Promise.all(Object.keys(artworkUrls).map(function (key) {
      return new Promise(function (resolve, reject) {
        if (!artworkUrls[key]) {
          resolve();
          return;
        }

        var image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = resolve;
        image.onerror = reject;
        image.src = artworkUrls[key];
        imageCache[key] = image;
      });
    }));
  }

  function copyCanvas(source, destination) {
    var context = destination.getContext('2d');
    context.clearRect(0, 0, textureWidth, textureHeight);
    context.drawImage(source, 0, 0);
  }

  function blendCanvas(from, to, destination, progress) {
    var context = destination.getContext('2d');
    context.clearRect(0, 0, textureWidth, textureHeight);
    context.globalAlpha = 1;
    context.drawImage(from, 0, 0);
    context.globalAlpha = progress;
    context.drawImage(to, 0, 0);
    context.globalAlpha = 1;
  }

  function buildScene() {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(24, 1, .1, 100);
    previewGroup = new THREE.Group();
    previewGroup.position.y = homepagePreviewVerticalOffset;
    scene.add(previewGroup);

    renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      powerPreference: 'low-power'
    });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, narrowScreen ? 1.75 : 1.5));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    host.appendChild(renderer.domElement);

    var maximumAnisotropy = renderer.capabilities.getMaxAnisotropy();
    frontTexture = new THREE.CanvasTexture(frontCanvas);
    backTexture = new THREE.CanvasTexture(backCanvas);
    frontTexture.colorSpace = THREE.SRGBColorSpace;
    backTexture.colorSpace = THREE.SRGBColorSpace;
    frontTexture.anisotropy = Math.min(8, maximumAnisotropy);
    backTexture.anisotropy = Math.min(8, maximumAnisotropy);

    sleeve = window.ERSChopstickSleeveGeometry.create(
      THREE,
      frontTexture,
      backTexture
    );
    sleeve.scale.setScalar(homepageSleeveScale);
    previewGroup.add(sleeve);

    var chopsticks = new THREE.Group();
    var chopstickGeometry = new THREE.CylinderGeometry(.034, .068, 5.8, 8);

    /*
     * One restrained bamboo surface keeps the shafts visibly related as a
     * manufactured twin. Variation runs with the length and remains in the
     * color map only—there is no coarse bump or glossy wood treatment.
     */
    var bambooCanvas = document.createElement('canvas');
    bambooCanvas.width = 64;
    bambooCanvas.height = 256;
    var bambooContext = bambooCanvas.getContext('2d');
    var bambooBase = bambooContext.createLinearGradient(0, 0, 64, 0);
    bambooBase.addColorStop(0, '#d4b477');
    bambooBase.addColorStop(.28, '#e2c78f');
    bambooBase.addColorStop(.58, '#ddbf83');
    bambooBase.addColorStop(1, '#cfae70');
    bambooContext.fillStyle = bambooBase;
    bambooContext.fillRect(0, 0, 64, 256);

    [
      { x: 8, color: '#b9955d', alpha: .10 },
      { x: 18, color: '#f2dfb4', alpha: .16 },
      { x: 31, color: '#b99055', alpha: .08 },
      { x: 45, color: '#f5e3bc', alpha: .14 },
      { x: 56, color: '#b28d55', alpha: .08 }
    ].forEach(function (fiberLine, index) {
      bambooContext.beginPath();
      bambooContext.moveTo(fiberLine.x, 0);
      bambooContext.bezierCurveTo(
        fiberLine.x + (index % 2 ? 1.2 : -.8),
        82,
        fiberLine.x + (index % 2 ? -.7 : 1),
        174,
        fiberLine.x,
        256
      );
      bambooContext.globalAlpha = fiberLine.alpha;
      bambooContext.strokeStyle = fiberLine.color;
      bambooContext.lineWidth = index === 1 || index === 3 ? 1.2 : .75;
      bambooContext.stroke();
    });
    bambooContext.globalAlpha = 1;

    var bambooTexture = new THREE.CanvasTexture(bambooCanvas);
    bambooTexture.colorSpace = THREE.SRGBColorSpace;
    bambooTexture.anisotropy = Math.min(4, maximumAnisotropy);

    var bambooMaterial = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      map: bambooTexture,
      roughness: .91,
      metalness: 0
    });

    [
      { y: -.7, z: .30 },
      { y: -.8, z: .40 }
    ].forEach(function(position) {
      var chopstick = new THREE.Mesh(chopstickGeometry, bambooMaterial);
      chopstick.rotation.z = -Math.PI / 2;
      chopstick.position.set(.1, position.y, position.z);
      chopstick.castShadow = true;
      chopstick.receiveShadow = true;
      chopsticks.add(chopstick);
    });

    /*
     * A short, softly edged web joins the thick ends, matching disposable
     * Bamboo Twin construction while leaving the existing shaft length, taper,
     * axes, and overall placement intact.
     */
    var webShape = new THREE.Shape();
    webShape.moveTo(-.31, -.08);
    webShape.lineTo(.31, -.08);
    webShape.lineTo(.31, .08);
    webShape.lineTo(-.31, .08);
    webShape.closePath();
    var webGeometry = new THREE.ExtrudeGeometry(webShape, {
      depth: .05,
      bevelEnabled: true,
      bevelSegments: 1,
      bevelSize: .01,
      bevelThickness: .008,
      curveSegments: 1
    });
    webGeometry.translate(0, 0, -.025);
    var connectingWeb = new THREE.Mesh(webGeometry, bambooMaterial);
    connectingWeb.position.set(-2.49, -.75, .35);
    connectingWeb.rotation.x = Math.PI * .75;
    connectingWeb.castShadow = true;
    connectingWeb.receiveShadow = true;
    chopsticks.add(connectingWeb);

    previewGroup.add(chopsticks);

    scene.add(new THREE.HemisphereLight(0xfffdf7, 0xa8aaa4, 1.7));
    var keyLight = new THREE.DirectionalLight(0xfff9ef, 2.2);
    keyLight.position.set(-3.5, 4.5, 5);
    keyLight.castShadow = true;
    keyLight.shadow.mapSize.set(narrowScreen ? 512 : 1024, narrowScreen ? 512 : 1024);
    keyLight.shadow.camera.near = .1;
    keyLight.shadow.camera.far = 20;
    scene.add(keyLight);

    var fillLight = new THREE.DirectionalLight(0xe5eced, .65);
    fillLight.position.set(4, 1, 3);
    scene.add(fillLight);

    var ground = new THREE.Mesh(
      new THREE.PlaneGeometry(18, 8),
      new THREE.ShadowMaterial({ color: 0x0d2421, opacity: .3 })
    );
    ground.rotation.x = -Math.PI / 2;
    ground.position.y = -.39;
    ground.receiveShadow = true;
    scene.add(ground);

    sleeve.rotation.set(-.045, -.42, 0);
    resize();
    renderer.domElement.addEventListener('webglcontextlost', handleContextLost, false);
    renderer.domElement.addEventListener('webglcontextrestored', handleContextRestored, false);
  }

  function frameCamera(width, height) {
    if (!camera) return;
    width = width || host.clientWidth;
    height = height || host.clientHeight;
    if (!width || !height) return;
    if (width === framedWidth && height === framedHeight) return;
    framedWidth = width;
    framedHeight = height;

    camera.aspect = width / height;
    var verticalTangent = Math.tan(THREE.MathUtils.degToRad(camera.fov * .5));
    var horizontalTangent = verticalTangent * camera.aspect;
    var frameFill = .96;
    var fittedDistance = 0;

    /*
     * Fit the actual scaled sleeve bounds across its complete orbit. The prior
     * single-angle estimate used the old .06 half-depth and clipped on the
     * homepage viewer's very wide desktop aspect ratio.
     */
    for (var frameStep = 0; frameStep < 24; frameStep++) {
      var frameRotation = frameStep / 24 * Math.PI * 2;
      var rotationCosine = Math.cos(frameRotation);
      var rotationSine = Math.sin(frameRotation);
      for (var widthSign = -1; widthSign <= 1; widthSign += 2) {
        var x = sleeveHalfWidth * widthSign;
        for (var depthSign = -1; depthSign <= 1; depthSign += 2) {
          var z = sleeveHalfDepth * depthSign;
          var rotatedX = x * rotationCosine + z * rotationSine;
          var rotatedZ = -x * rotationSine + z * rotationCosine;
          fittedDistance = Math.max(
            fittedDistance,
            rotatedZ + Math.max(
              Math.abs(rotatedX) / (horizontalTangent * frameFill),
              sleeveHalfHeight / (verticalTangent * frameFill)
            )
          );
        }
      }
    }

    camera.position.set(0, .25, fittedDistance);
    camera.lookAt(0, 0, 0);
    camera.updateProjectionMatrix();
  }

  function resize() {
    if (!renderer) return false;
    var width = host.clientWidth;
    var height = host.clientHeight;
    if (!width || !height) return false;
    if (width !== renderedWidth || height !== renderedHeight) {
      renderer.setSize(width, height, false);
      renderedWidth = width;
      renderedHeight = height;
    }
    frameCamera(width, height);
    renderScene();
    return true;
  }

  function renderScene() {
    if (renderer && scene && camera && !destroyed) renderer.render(scene, camera);
  }

  function beginSampleTransition(now, frameRotation) {
    sequenceIndex = (sequenceIndex + 1) % previewSequence.length;
    var nextIndex = previewSequence[sequenceIndex];
    var backFaceVisible = Math.cos(frameRotation) < 0;
    var nextSampleReversed =
      (!!startOnFrontSamples[nextIndex] && backFaceVisible) ||
      (!!startOnBackSamples[nextIndex] && !backFaceVisible);
    copyCanvas(frontCanvas, transitionFront);
    copyCanvas(backCanvas, transitionBack);
    drawSample(nextIndex, targetFront, targetBack, nextSampleReversed);
    currentSample = nextIndex;
    currentSampleReversed = nextSampleReversed;
    root.setAttribute('data-active-sample', samples[currentSample].name);
    transitionStartedAt = now;
    changeIndex += 1;
    nextSampleAt =
      Math.floor(changeIndex / sampleChangesPerRotation) * rotationDuration +
      changePoints[changeIndex % sampleChangesPerRotation];
  }

  function updateSampleTransition(now) {
    if (transitionStartedAt < 0) return;
    var progress = Math.min(1, (now - transitionStartedAt) / transitionDuration);
    var eased = progress * progress * (3 - 2 * progress);
    blendCanvas(transitionFront, targetFront, frontCanvas, eased);
    blendCanvas(transitionBack, targetBack, backCanvas, eased);
    frontTexture.needsUpdate = true;
    backTexture.needsUpdate = true;
    if (progress >= 1) transitionStartedAt = -1;
  }

  function animate(now) {
    frameRequest = null;
    if (!shouldAnimate()) {
      lastFrameTime = 0;
      return;
    }

    if (!lastFrameTime) lastFrameTime = now;
    elapsed += Math.min(50, now - lastFrameTime);
    lastFrameTime = now;

    var phase = (elapsed % rotationDuration) / rotationDuration;
    var orbit = phase * Math.PI * 2;
    var frameRotation = -sleeveYawOffset + orbit;
    sleeve.rotation.y = frameRotation;
    sleeve.rotation.x = -.045 + Math.sin(orbit) * .003;
    sleeve.rotation.z = Math.sin(orbit + .8) * .0015;
    sleeve.position.y = Math.sin(orbit) * .002;

    if (elapsed >= nextSampleAt && transitionStartedAt < 0) {
      beginSampleTransition(now, frameRotation);
    }
    updateSampleTransition(now);
    renderScene();
    frameRequest = window.requestAnimationFrame(animate);
  }

  function isSlideActive() {
    if (!slide || !slider) return true;
    if (!slider.classList.contains('loaded')) return true;
    return slide.classList.contains('flex-active-slide') ||
      slide.getAttribute('aria-hidden') === 'false';
  }

  function shouldAnimate() {
    return !destroyed &&
      !reducedMotion &&
      !root.classList.contains('is-fallback') &&
      root.classList.contains('is-ready') &&
      inViewport &&
      !document.hidden &&
      isSlideActive();
  }

  function syncPlayback() {
    if (shouldAnimate()) {
      if (!frameRequest) frameRequest = window.requestAnimationFrame(animate);
    } else {
      if (frameRequest) window.cancelAnimationFrame(frameRequest);
      frameRequest = null;
      lastFrameTime = 0;
      renderScene();
    }
  }

  function handleContextLost(event) {
    event.preventDefault();
    revealScheduled = false;
    root.classList.remove('is-ready');
    root.classList.add('is-fallback');
    syncPlayback();
  }

  function handleContextRestored() {
    root.classList.remove('is-fallback');
    if (resize()) revealViewer();
  }

  function failGracefully() {
    root.classList.remove('is-ready');
    root.classList.add('is-fallback');
    host.setAttribute('aria-busy', 'false');
  }

  function revealViewer() {
    if (revealScheduled) return;
    revealScheduled = true;
    window.requestAnimationFrame(function () {
      if (destroyed) return;
      root.classList.add('is-ready');
      host.setAttribute('aria-busy', 'false');
      syncPlayback();
    });
  }

  function tryCompleteInitialization() {
    if (slider && !slider.classList.contains('loaded')) return false;
    if (!resize()) return false;

    if (sizeObserver) sizeObserver.disconnect();
    if (layoutObserver) layoutObserver.disconnect();
    sizeObserver = null;
    layoutObserver = null;
    revealViewer();
    return true;
  }

  function completeInitialization() {
    bindLifecycle();
    if (tryCompleteInitialization()) return;

    if ('ResizeObserver' in window) {
      sizeObserver = new ResizeObserver(function () {
        tryCompleteInitialization();
      });
      sizeObserver.observe(host);
    }

    if (slider && 'MutationObserver' in window) {
      layoutObserver = new MutationObserver(function () {
        window.requestAnimationFrame(tryCompleteInitialization);
      });
      layoutObserver.observe(slider, { attributes: true, attributeFilter: ['class'] });
    }

    if (!sizeObserver && !layoutObserver) {
      window.requestAnimationFrame(completeInitialization);
    }
  }

  function bindLifecycle() {
    if (lifecycleBound) return;
    lifecycleBound = true;
    document.addEventListener('visibilitychange', syncPlayback);
    window.addEventListener('resize', resize);
    window.addEventListener('pagehide', destroy, { once: true });

    if (reducedMotionQuery) {
      var motionChange = function (event) {
        reducedMotion = event.matches;
        syncPlayback();
      };
      if (reducedMotionQuery.addEventListener) reducedMotionQuery.addEventListener('change', motionChange);
      else if (reducedMotionQuery.addListener) reducedMotionQuery.addListener(motionChange);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inViewport = entries[0].isIntersecting;
        syncPlayback();
      }, { threshold: .08 }).observe(root);
    }

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(syncPlayback);
      if (slide) observer.observe(slide, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      if (slider) observer.observe(slider, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function destroy() {
    destroyed = true;
    if (sizeObserver) sizeObserver.disconnect();
    if (layoutObserver) layoutObserver.disconnect();
    sizeObserver = null;
    layoutObserver = null;
    if (frameRequest) window.cancelAnimationFrame(frameRequest);
    frameRequest = null;
    if (renderer) renderer.dispose();
  }

  function init() {
    root.setAttribute('data-active-sample', samples[currentSample].name);

    if (
      typeof window.THREE === 'undefined' ||
      !window.ERSChopstickSleeveGeometry
    ) {
      failGracefully();
      return;
    }

    preloadArtwork().then(function () {
      if (destroyed) return;
      drawSample(currentSample, frontCanvas, backCanvas, currentSampleReversed);

      try {
        buildScene();
      } catch (error) {
        failGracefully();
        return;
      }

      completeInitialization();
    }).catch(failGracefully);
  }

  init();
}());
